import {
  CURRENT_FEATURE_INDEX,
  FeaturesBanner,
} from "@/components/atoms/FeaturesBanner/FeaturesBanner";
import { cn } from "@/lib/utils";
import { setTopToPage } from "@/redux/globalState/globalStateSlice";
import { AppDispatch } from "@/redux/store";
import {
  Subscription,
  canUseClubImportSelector,
  getUserSelector, // sendMyGroupIdToServer,
  userIsLoggedInSelector,
  userSubscriptionSelector,
} from "@/redux/user/userSlice";
import { BREAKPOINTS } from "@/settings";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useMediaQuery } from "usehooks-ts";

import { NavBarDesktop } from "./NavBarDesktop/NavBarDesktop";
import { NavBarTouchDevice } from "./NavBarTouchDevice/NavBarTouchDevice";

interface NavigationBarProps {
  currentRoute: string;
}

const NavigationBar = ({ currentRoute }: NavigationBarProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector(getUserSelector);
  const canUseClubImport =
    useSelector(canUseClubImportSelector) ||
    localStorage.getItem("canUseClubImport") === "true";
  const userIsLoggedIn =
    useSelector(userIsLoggedInSelector) ||
    localStorage.getItem("loggedIn") === "true";
  const userSubscription =
    useSelector(userSubscriptionSelector) ||
    (localStorage.getItem("subscription") as unknown as Subscription);
  const freeUser = useMemo(
    () => !userSubscription || userSubscription === "free",
    [userSubscription],
  );
  const paidUserButNotUltimate = useMemo(
    () => userSubscription === "silver" || userSubscription === "gold",
    [userSubscription],
  );
  const isTouchDevice = useMediaQuery(BREAKPOINTS.TOUCH_DEVICE.query);
  const [closedBanner, setClosedBanner] = useState(
    localStorage.getItem(`closed-feature-banner-${CURRENT_FEATURE_INDEX}`) ===
      "true",
  );

  const handleCloseBanner = () => {
    localStorage.setItem(
      `closed-feature-banner-${CURRENT_FEATURE_INDEX}`,
      "true",
    );
    setClosedBanner(true);
  };

  useEffect(() => {
    if (isTouchDevice) {
      if (closedBanner) {
        dispatch(setTopToPage({ value: 0, tailwindString: "top-0" }));
      } else {
        dispatch(setTopToPage({ value: 36, tailwindString: "top-9" }));
      }
    } else {
      if (closedBanner) {
        dispatch(setTopToPage({ value: 48, tailwindString: "top-12" }));
      } else {
        dispatch(setTopToPage({ value: 84, tailwindString: "top-21" }));
      }
    }
  }, [isTouchDevice, closedBanner]);

  const handleClick = ({ isPaywalled }: { isPaywalled: boolean }) => {
    window.scrollTo(0, 0);

    if (user.subscription === "diamond" || !isPaywalled) {
      // means you're ultimate user or you're not trying to access My Club.
      return;
    }

    // Outcommenting this because we'll set up another experiment soon

    // let localMyClubGroupId =
    //   user.myClubGroupId || localStorage.getItem("myClubGroupId");
    // // it means that you you have been assigned to a group at some point.
    // const isElite = user.subscription === "gold";

    // if (
    //   isElite &&
    //   localMyClubGroupId?.startsWith(EXPERIMENT_ID_MY_CLUB_IS_FREE)
    // ) {
    //   // At some point you were free, and assigned to a group. Now you're elite and should be assigned to a new group.
    //   const rand = Math.random();
    //   const randomId = rand < 1 / 3 ? "A" : rand < 2 / 3 ? "B" : "C";
    //   localMyClubGroupId = EXPERIMENT_ID_MY_CLUB_IS_ELITE + "-" + randomId;
    //   localStorage.setItem("myClubGroupId", localMyClubGroupId);
    //   fireGTMEvent(EXPERIMENT_EVENTS.USER_IS_IN_EXPERIMENT, {
    //     testGroup: localMyClubGroupId,
    //   });
    // } else if (isElite && !localMyClubGroupId) {
    //   const rand = Math.random();
    //   const randomId = rand < 1 / 3 ? "A" : rand < 2 / 3 ? "B" : "C";
    //   localMyClubGroupId = EXPERIMENT_ID_MY_CLUB_IS_ELITE + "-" + randomId;
    //   localStorage.setItem("myClubGroupId", localMyClubGroupId);
    //   fireGTMEvent(EXPERIMENT_EVENTS.USER_IS_IN_EXPERIMENT, {
    //     testGroup: localMyClubGroupId,
    //   });
  };
  // if (
  //   user.uuid &&
  //   localMyClubGroupId &&
  //   localMyClubGroupId !== user.myClubGroupId
  // ) {
  //   dispatch(sendMyGroupIdToServer(localMyClubGroupId));
  // }

  return (
    <>
      {!closedBanner && <FeaturesBanner onClose={handleCloseBanner} />}
      {isTouchDevice ? (
        <NavBarTouchDevice
          currentRoute={currentRoute}
          userIsLoggedIn={userIsLoggedIn}
          canUseClubImport={canUseClubImport}
          freeUser={freeUser}
          paidUserButNotUltimate={paidUserButNotUltimate}
          userSubscription={userSubscription}
          handleClick={handleClick}
        />
      ) : (
        <div
          className={cn("sticky w-full z-40", closedBanner ? "top-0" : "top-9")}
        >
          <NavBarDesktop
            currentRoute={currentRoute}
            userIsLoggedIn={userIsLoggedIn}
            userSubscription={userSubscription}
            freeUser={freeUser}
            paidUserButNotUltimate={paidUserButNotUltimate}
            handleClick={handleClick}
          />
        </div>
      )}
    </>
  );
};

export default NavigationBar;
